// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ucFL","buttons":"styles_buttons__2TG0Y"};